import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { MachineComponentModel, MachineComponentWorkplaceModel, MachineComponentStationModel } from '@/libs/Api';
import { MachineComponentsDataService } from '@/libs/machine-components/machine-components-data-service';
import { MachineComponentWorkplacesDataService } from '@/libs/machine-components/machine-component-workplaces-data-service';
import { MachineComponentStationsDataService } from '@/libs/machine-components/machine-component-stations-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const machineComponentsStore = registerCrudStore<MachineComponentModel, MachineComponentModel>(
    BusinessModule.MachineComponent,
    new MachineComponentsDataService()
);

export const machineComponentWorkplacesStore = registerCrudStore<MachineComponentWorkplaceModel, MachineComponentWorkplaceModel>(
    BusinessModule.MachineComponentWorkplace,
    new MachineComponentWorkplacesDataService()
);

export const machineComponentStationsStore = registerCrudStore<MachineComponentStationModel, MachineComponentStationModel>(
    BusinessModule.MachineComponentStation,
    new MachineComponentStationsDataService()
);

